import type { PropType } from '@/composition/vue/compositionApi'
import type { TmAvatarPlaceholder } from '@/components/shared/types'
import type { AllAvatarColors } from '@/constants/avatar'
import type { IconName } from '@/assets/icons/icons'

import type { EmojiNative } from '@/services/forms/tmTiptap/types'

interface IDetailsHeroInfoBase {
  label: string
  fitContent?: boolean
  labelStyle?: Pick<CSSStyleDeclaration, 'overflow'>
}

interface IDetailsHeroInfoLink extends IDetailsHeroInfoBase {
  url: string
  isDisabled?: undefined
  onClick?: undefined
}

interface IDetailsHeroInfoButton extends IDetailsHeroInfoBase {
  url?: undefined
  isDisabled?: boolean
  onClick: () => void
}

interface IDetailsHeroInfoText extends IDetailsHeroInfoBase {
  url?: undefined
  isDisabled?: undefined
  onClick?: undefined
}

export type DetailsHeroInfo = IDetailsHeroInfoLink | IDetailsHeroInfoButton | IDetailsHeroInfoText

export const detailsHeroProps = {
  title: {
    type: String,
  },
  titleEditable: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String as PropType<IconName>,
  },
  iconUrl: {
    type: String,
  },
  iconClass: {
    type: String,
  },
  infos: {
    type: Array as PropType<DetailsHeroInfo[]>,
  },
  avatarSize: {
    type: String,
    default: '40px',
  },
  avatarColor: {
    type: String as PropType<AllAvatarColors>,
    default: 'blue200',
  },
  avatarPlaceholderSize: {
    type: String,
    default: '24px',
  },
  avatarPlaceholderType: {
    type: String as PropType<TmAvatarPlaceholder>,
    default: 'icon',
  },
  avatarStatusOffsetPx: {
    type: Number,
    default: 4,
  },
  squareAvatar: {
    type: Boolean,
  },
  maxVisibleItems: {
    type: Number,
    default: 4,
  },
  dropdownCloseOnClick: {
    type: Boolean,
  },
  emoji: {
    type: String as PropType<EmojiNative>,
  },
} as const
